const mainColor500 = '#DC812D';
const mainColor400 = '#E58933';
const mainColor300 = '#F29102';
const mainColor200 = '#F8A21F';
const mainColor100 = '#F8AF02';
const subColor500 = '#31185F';
const subColor400 = '#502C94';
const subColor300 = '#6325E2';
const subColor200 = '#894FFE';
const subColor100 = '#9365F0';


export default { mainColor500, mainColor400, mainColor300, mainColor200, mainColor100, subColor500, subColor400, subColor300, subColor200, subColor100 };